import NavBar from '../home/components/NavBar';
import CoCreatorSection from '../home/components/CoCreatorSection';
import RegisterSection from '../home/components/RegisterSection';
import Footer from '../home/components/Footer';

export default function CoCreatorPage() {
  return (
    <main className="min-h-screen bg-[#EFEBE5]">
      <NavBar />
      <div className="pt-20">
        <CoCreatorSection />
        <RegisterSection />
      </div>
      <Footer />
    </main>
  );
}
